// extracted by mini-css-extract-plugin
export var primary = "tag-module--primary--9590a";
export var secondary = "tag-module--secondary--5132d";
export var tag = "tag-module--tag--f8cb6";
export var tertiary = "tag-module--tertiary--7d0b8";